import { href } from "../../App/href";

export const navLinks = [
  {
    href: href("~/builder"),
    heading: "Builder",
    summary:
      "Build your perfect warband and share it with your friends (and enemies!).",
  },
  {
    href: href("~/shop"),
    heading: "Shop",
    summary:
      "Download or buy the latest Greathelm content, right here in the app.",
  },
  {
    href: href("~/docs"),
    heading: "Help & Changelog",
    summary: "Get support and learn what's new in the app.",
  },
];
